import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class ObjectPropertiesService {

    constructor() { }

    getValue(object, property) {
        const properties = property.split(".");
        let data;

        properties.forEach(prop => {
            if (!data)
                data = object[prop];
            else
                data = data[prop];
        });

        return data;
    }
}